import styled, { css } from "styled-components";

import React, {
  Fragment,
  useState,
  useContext,
  useEffect,
  Component
} from "react";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

// import { ContextConsumer } from "../App";

// import CardNew, { CardFlatten } from "./PAcardNew";
import { ProductIcon } from "../../data/ProductIcon";

import Tap from "react-interactions";


import {
  InputCopy,
  FormGroup,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Subheader,
  Button,
  Card,
  Input,
  RadioGroup,
  Icon,
  ButtonAction,
  Tag,
  Notification
} from "xsolla-uikit";

import { xsollaProducts } from '../../data/xsollaProducts';













export default function PAtopMenu ({
  size = 'md',
  products = xsollaProducts,
  renderProducts = [],
  activeItem = "ingame",
  active = 'game_store',
  pathname = '/game_store',
  selected = [],
}) {
  // let solutionsState = useContext(MenuContext);

  renderProducts = renderProducts.length ? renderProducts : Object.keys(products);

  const [state, setState] = useState({
    // products,
    hovered: active,
    menuCount: countMenu(products),
  });


  useEffect(()=>{
    console.log('renderProducts = ', renderProducts);
    console.log('pathname = ', pathname);
  })

  console.log('renderProducts = ', renderProducts);
  return (
    <CssMenuItem>

      {renderProducts.map((oneProductId, i) => {
        let oneProduct = products[oneProductId];
        return (
          !selected.length
          && oneProduct
          && !oneProduct["external"]
          && !oneProduct["sub"])
          || (!!selected.length && selected.indexOf(oneProductId) >= 0)
        ? (
          <Link
            key={`${oneProductId}_${i}`}
            to={oneProduct["link"] || ''}
            // className={`sidebar-products__item sidebar-products__item--misha ${
            //   // activeItem === oneProduct["link"] ||
            //   // pathname === oneProduct["link"]
            //   pathname.indexOf(oneProductId) > -1
            //     ? ` sidebar-products__item--active sidebar-products__item--active--misha`
            //     : ''
            // }`}
            style={{
              display:'flex',
              justifyContent:'center',
              padding:'4px',
            }}
          >
            <CssSelected active={selected.indexOf(oneProductId) >= 0 ? true : false}>
              <Tap waves fade={0.1} />

              <MenuItem
                size={size}
                appearance="horizontal"
              // className="sidebar-products__icon-wrapper--misha"
              >
                {/* {!oneProduct['connected'] && <div style={{right: 0}} className="sidebar-products__status sidebar-products__status--disconnected" />}
                {oneProduct['connected'] && <div style={{right: 0}} className="sidebar-products__status sidebar-products__status--connected" />} */}

                <CssProductIcon size={size}>
                  <ProductIcon size={size} name={oneProductId} color="white" />
                </CssProductIcon>

                <CssProductName>{oneProduct["name"]}</CssProductName>
              </MenuItem>
            </CssSelected>
          </Link>
        ) : null;
      })}

    </CssMenuItem>
  );
};




const CssSelected = styled.div`
  /* min-width: 220px; */
  /* height: 80px; */
  background-color: repeat(
    ${props => props.active ? `red` : `blue`}
  );
`


export const countMenu = (products = xsollaProducts) => {
  let count = 0;
  Object.keys(products).forEach(oneProductId => {
    let oneProduct = products[oneProductId];
    count = !oneProduct["external"] && !oneProduct["sub"] ? count + 1 : count;
  });
  return count;
};



const MenuCont = styled.div`
  min-height: 60px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  transition: all 0.2s ease;
  min-width: 220px;
  ${props =>
    props.menu &&
    css`
      min-height: 800px;
    `}
  ${props =>
    props.hide &&
    css`
      opacity: 1;
    `}

`

const CssMenuItem = styled.div`
  display: flex;
  width: 100%;
  /* justify-content: center; */
  transition: all 0.2s ease;

`

export const MenuSol = styled.div`
  width: 100%;
  margin: 0 auto;
  max-width: 1080px;
  position: absolute;
  /* display: grid; */
  /* grid-template-columns: repeat(4, minmax(100px, auto)); */
  top: 140px;
  /* grid-template-columns: repeat(
    ${props => props.count},
    1fr
  ); */
  /* place-content: center center; */
  /* grid-column-gap: ${props => `${props.count > 4 ? 3 : props.count}%`}; */
`;
export const MenuItem = styled.div`
  /* height: 56px; */
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  text-align: center;
  /* margin-bottom: 8px; */
  ${({appearance})=> !!appearance && css`
    flex-direction: row;
    text-align: left;
    display: flex;
    font-family: 'Sharp Grotesk 15', sans-serif;
    color: black;
    font-size: 18px;
  `}
  ${({size})=> size === 'sm' && css`
    font-size: 16px;
  `}
`;

export const CssProductIcon = styled.div`
margin: 0 8px 0 0;
display: flex;
align-items: center;
justify-content: center;
  /* margin-right: 6px;
  margin-top: -6px; */
  height: 36px;
  width: 36px;
  ${({size}) => size && size === 'sm' && css`
    height: 24px;
    width: 24px;
  `}
  ${({size}) => size && size === 'lg' && css`
    height: 64px;
    width: 64px;
  `}
  background-color: #0073f7;
  color: #f7faff;
`;

export const CssProductName = styled.div`
  /* font-weight: bolder; */
  line-height: 120%;
`;



export const CSSmenuAbs = styled.div`
  width: 100%;
  margin: 0 auto;
  max-width: 1080px;
  position: absolute;
  top: 40px;
`

const MenuUl = styled.div`
  width: 100%;
  margin: 0 auto;
  max-width: 1080px;
  /* display: grid; */
  display: flex;
  /* grid-template-columns: repeat(auto-fit, minmax(100px, 220px)); */
  /* grid-template-columns: repeat(
    ${props => props.count},
    ${props => `${100 / props.count}%`}
  ); */
  /* place-content: center center; */
  /* grid-column-gap: ${props => `${props.count > 4 ? 3 : props.count}%`}; */
`